import { apiRequest } from './api';
import { BenchmarkQuestion } from '../store/benchmark/types';
import { QueryType } from '../types/QueryTypes';

interface GetBenchmarkQuestionsParams {
  page?: number;
  limit?: number;
  query_type?: QueryType;
  user_persona?: string;
}

export interface PaginatedBenchmarkResponse {
  data: BenchmarkQuestion[];
  total: number;
}

export const getBenchmarkQuestions = async (
  params: GetBenchmarkQuestionsParams,
): Promise<PaginatedBenchmarkResponse> => {
  const queryParams: Record<string, string> = {};

  if (params.page) queryParams.page = params.page.toString();
  if (params.limit) queryParams.limit = params.limit.toString();
  if (params.query_type) queryParams.query_type = params.query_type;
  if (params.user_persona) queryParams.user_persona = params.user_persona;

  return apiRequest<PaginatedBenchmarkResponse>('/admin/benchmark', { params: queryParams });
};

export const createBenchmarkQuestion = async (
  data: Partial<BenchmarkQuestion>,
): Promise<BenchmarkQuestion> => {
  return apiRequest<BenchmarkQuestion>('/admin/benchmark', {
    method: 'POST',
    data,
  });
};

export const updateBenchmarkQuestion = async (
  id: string,
  data: Partial<BenchmarkQuestion>,
): Promise<BenchmarkQuestion> => {
  return apiRequest<BenchmarkQuestion>(`/admin/benchmark/${id}`, {
    method: 'PUT',
    data,
  });
};

export const deleteBenchmarkQuestion = async (id: string): Promise<void> => {
  return apiRequest<void>(`/admin/benchmark/${id}`, {
    method: 'DELETE',
  });
};

export interface BenchmarkEvalResponse {
  triggerId: string;
  jobId: string;
}

export interface JobStatusResponse {
  isCompleted: boolean;
  isFailed: boolean;
}

export const evaluateBenchmarkQuestions = async (): Promise<BenchmarkEvalResponse> => {
  return apiRequest<BenchmarkEvalResponse>('/admin/benchmark/evaluate', {
    method: 'POST',
  });
};

export const getJobStatus = async (jobId: string): Promise<JobStatusResponse> => {
  return apiRequest<JobStatusResponse>(`/jobs/${jobId}/status`);
};
